import React, { useState } from "react";
import Seo, { breadcrumbSchema } from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { BookButton } from "@/components/ui-bits";
import { Stagger, StaggerItem } from "@/components/Reveal";
import { GALLERY, IMAGES } from "@/lib/site";

export default function Gallery() {
  const [lightbox, setLightbox] = useState(null);
  return (
    <>
      <Seo
        title="Photo Gallery | Regency Inn & Suites, Pittsburg KS"
        description="See real photos of Regency Inn & Suites in Pittsburg, Kansas — our clean king and two-queen guest rooms, breakfast area and lobby."
        path="/gallery"
        image={IMAGES.heroFacade}
        schema={[breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Gallery", path: "/gallery" }])]}
      />
      <PageHero
        eyebrow="Photo Gallery"
        title="Real rooms. Real welcome."
        subtitle="Every photo here is our actual hotel — clean, comfortable rooms and warm spaces, exactly as you'll find them."
        image={IMAGES.roomPillows}
        crumbs={[{ name: "Home", path: "/" }, { name: "Gallery", path: "/gallery" }]}
      />
      <section className="bg-bone py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <Stagger className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
            {GALLERY.map((g, i) => (
              <StaggerItem key={i} className="mb-5 break-inside-avoid">
                <button
                  onClick={() => setLightbox(g)}
                  data-testid={`gallery-img-${i}`}
                  className="img-zoom block w-full rounded-md"
                >
                  <img src={g.src} alt={g.alt} loading="lazy" className="w-full h-auto object-cover" />
                </button>
              </StaggerItem>
            ))}
          </Stagger>
          <div className="mt-16 text-center">
            <BookButton label="Book Your Room" testid="gallery-book" />
          </div>
        </div>
      </section>

      {lightbox && (
        <div
          className="fixed inset-0 z-[70] bg-forest-deep/95 flex items-center justify-center p-6"
          onClick={() => setLightbox(null)}
          data-testid="gallery-lightbox"
        >
          <button className="absolute top-6 right-8 text-bone text-4xl" data-testid="lightbox-close">×</button>
          <figure className="max-w-5xl">
            <img src={lightbox.src} alt={lightbox.alt} className="w-full max-h-[80vh] object-contain rounded-md" />
            <figcaption className="text-bone/70 text-sm mt-4 text-center">{lightbox.alt}</figcaption>
          </figure>
        </div>
      )}
    </>
  );
}
